module.exports = __webpack_public_path__ + "static/media/payment_type.0812bf86.svg";